import React, { useState, useEffect, useCallback } from "react";
import {
  Container, Paper, Typography, Button, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, MenuItem, Switch, FormControlLabel, Chip, makeStyles
} from "@material-ui/core";
import { Add, Edit, Delete } from "@material-ui/icons";
import { getAutoAssignRules, createAutoAssignRule, updateAutoAssignRule, deleteAutoAssignRule } from "../../services/api.new-features";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  paper: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
}));

const methods = [
  { value: "round-robin", label: "Round Robin" },
  { value: "load-balanced", label: "Balanceado por Carga" },
  { value: "least-busy", label: "Menos Ocupado" },
];

const AutoAssignRules = () => {
  const classes = useStyles();
  const [rules, setRules] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [current, setCurrent] = useState({});

  const load = useCallback(async () => {
    try { const res = await getAutoAssignRules(); setRules(res.data); }
    catch (e) { toast.error("Erro ao carregar regras"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    try {
      if (current.id) { await updateAutoAssignRule(current.id, current); }
      else { await createAutoAssignRule(current); }
      setDialog(false); setCurrent({}); load();
      toast.success("Regra salva!");
    } catch (e) { toast.error("Erro ao salvar"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir regra?")) return;
    try { await deleteAutoAssignRule(id); load(); } catch (e) { toast.error("Erro"); }
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h5">Regras de Auto-Atribuição</Typography>
        <Button variant="contained" color="primary" startIcon={<Add />}
          onClick={() => { setCurrent({ method: "round-robin", isActive: true }); setDialog(true); }}>
          Nova Regra</Button>
      </div>

      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Fila</TableCell>
              <TableCell>Método</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rules.map(r => (
              <TableRow key={r.id}>
                <TableCell>{r.id}</TableCell>
                <TableCell>{r.queue?.name || "Todas"}</TableCell>
                <TableCell>
                  <Chip size="small" label={methods.find(m => m.value === r.method)?.label || r.method} color="primary" />
                </TableCell>
                <TableCell>
                  <Chip size="small" label={r.isActive ? "Ativo" : "Inativo"}
                    style={{ backgroundColor: r.isActive ? "#4caf50" : "#9e9e9e", color: "#fff" }} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => { setCurrent(r); setDialog(true); }}><Edit /></IconButton>
                  <IconButton size="small" onClick={() => handleDelete(r.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{current.id ? "Editar Regra" : "Nova Regra"}</DialogTitle>
        <DialogContent>
          <TextField fullWidth margin="dense" label="ID da Fila (vazio = todas)" type="number"
            value={current.queueId || ""} onChange={e => setCurrent({ ...current, queueId: e.target.value ? Number(e.target.value) : null })} />
          <TextField fullWidth margin="dense" label="Método" select value={current.method || "round-robin"}
            onChange={e => setCurrent({ ...current, method: e.target.value })}>
            {methods.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
          </TextField>
          <FormControlLabel control={
            <Switch checked={!!current.isActive} onChange={e => setCurrent({ ...current, isActive: e.target.checked })} />
          } label="Ativo" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AutoAssignRules;